<template>
  <div class="flex items-center space-x-1.5">
    <nav class="flex space-x-0.5" aria-label="Pagination">
      <!-- Previous button -->
      <button
        @click="$emit('previous')"
        :disabled="!hasPrevious || disabled"
        class="relative inline-flex items-center rounded-l-md px-2 py-1.5 text-muted-foreground border border-border hover:bg-gray-50 focus:z-20 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
      >
        <span class="sr-only">Previous</span>
        <ChevronLeft class="h-4 w-4" aria-hidden="true" />
      </button>

      <!-- Page numbers -->
      <template v-for="page in pageNumbers" :key="page">
        <button
          v-if="page !== '...'"
          @click="$emit('page-select', page as number)"
          :disabled="disabled"
          :class="[
            page === currentPage
              ? 'relative z-10 inline-flex items-center bg-gray-900 px-3 py-1.5 text-xs font-semibold text-white border border-gray-900'
              : 'relative inline-flex items-center px-3 py-1.5 text-xs font-medium text-gray-700 border border-border hover:bg-gray-50 focus:z-20 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed transition-colors'
          ]"
        >
          {{ page }}
        </button>
        <span
          v-else
          class="relative inline-flex items-center px-3 py-1.5 text-xs font-medium text-muted-foreground border border-border"
        >
          …
        </span>
      </template>

      <!-- Next button -->
      <button
        @click="$emit('next')"
        :disabled="!hasNext || disabled"
        class="relative inline-flex items-center rounded-r-md px-2 py-1.5 text-muted-foreground border border-border hover:bg-gray-50 focus:z-20 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
      >
        <span class="sr-only">Next</span>
        <ChevronRight class="h-4 w-4" aria-hidden="true" />
      </button>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { ChevronLeft, ChevronRight } from 'lucide-vue-next'

interface Props {
  pageNumbers: (number | string)[]
  currentPage: number
  hasPrevious: boolean
  hasNext: boolean
  disabled?: boolean
}

interface Emits {
  (e: 'page-select', page: number): void
  (e: 'previous'): void
  (e: 'next'): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>
